import {PLATFORM, FrameworkConfiguration} from 'aurelia-framework';
import './resources.scss';

export function configure(config: FrameworkConfiguration) {
  config.globalResources([
    PLATFORM.moduleName('./pagelayout/header/page-header'),
    PLATFORM.moduleName('./pagelayout/groupbar/group-bar'),
    PLATFORM.moduleName('./pagelayout/content/account/account-view-header'),
    PLATFORM.moduleName('./pagelayout/content/onebox/onebox-view-header'),
    PLATFORM.moduleName('./pagelayout/content/groups/groups-view-header'),
    PLATFORM.moduleName('./pagelayout/content/group/viewheader/view-header-settings'),
    PLATFORM.moduleName('./pagelayout/content/group/viewheader/view-header-applications'),
    PLATFORM.moduleName('./pagelayout/content/group/viewheader/view-header-reports'),
    PLATFORM.moduleName('./pagelayout/content/group/viewheader/view-header-billing'),
    PLATFORM.moduleName('./pagelayout/content/group/viewheader/group-directory-view-header.html'),
    PLATFORM.moduleName('./pagelayout/content/group/affiliation/group-affiliation'),
    PLATFORM.moduleName('./pagelayout/content/group/reports/group-report'),
    PLATFORM.moduleName('./pagelayout/content/search/search-view-header'),
    PLATFORM.moduleName('./pagelayout/content/ringplans/ringplans-view-header'),
    PLATFORM.moduleName('./pagelayout/content/widgets/widgets-view-header'),
    PLATFORM.moduleName('./pagelayout/content/notifications/notifications-view-header'),
    PLATFORM.moduleName('./pagelayout/content/contacts/contacts-view-header'),
    PLATFORM.moduleName('./controls/languageSwitcher/language-switcher'),
    PLATFORM.moduleName('./controls/scroll/scrolling-area'),
    PLATFORM.moduleName('./controls/scroll/scroll-update'),
    PLATFORM.moduleName('./controls/button/standard-button'),
    PLATFORM.moduleName('./controls/terms-eightysix-borders/terms-eightysix-borders'),
    PLATFORM.moduleName('./attributes/resizable'),
    PLATFORM.moduleName('./attributes/window-resize'),
    PLATFORM.moduleName('./attributes/repeat-lc'),
    PLATFORM.moduleName('./communication/widgetFrame/search-user-communication-frame'),
    PLATFORM.moduleName('./communication/search-communication-users')
  ]);
}
